import { render } from "./ExerciseEditView.vue?vue&type=template&id=7204a468&ts=true"
import script from "./ExerciseEditView.vue?vue&type=script&lang=ts"
export * from "./ExerciseEditView.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/stamincasa/stamincasa-matematica/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__